import { APIClient } from "../../../../api/api_helper";
import { GetUserData } from "../../../../common/service/CommonService";
import { USER_SSO_API, Admin_API } from "../../../../api/url_helper";

/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface CurrentUser {
  userid: number;
  compid?: number;
  branid?: number;
}

interface UserPayload {
  userid?: number | null;
  userassignmentid?: number | null;
  roleid?: number | null;
  username?: string;
  userdisplayname?: string;
  useremail?: string;
  rolename?: string;
  description?: string;
  createdby?: number;
  updatedby?: number;
  updatereason?: string | null;
}

/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * USER API
 * ------------------------------------------------------------------ */

export const userApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      userid: user?.userid ?? null,
      compid: user?.compid ?? null,
      branid: user?.branid ?? null,
      status: "A",
      searchtext: searchText === "" ? null : searchText,
      page: pageNumber,
      pagesize: pageSize,
    };
    return api.create(USER_SSO_API.USER_SSO_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (userid?: number | null) => {
    const payload = {
      userid: userid,
    };
    return api.create(USER_SSO_API.USER_SSO_API + "Select", payload);
  },

  // INSERT METHOD
  insertData: (payload_data: UserPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user?.userid,
      compid: user?.compid,
      branid: user?.branid,
      // moduleid: parseInt(sessionStorage.getItem("loginModuleId") || "0"),
      moduleid: process.env.REACT_APP_BYPASS_SSO === 'true'
        ? 3050
        : parseInt(sessionStorage.getItem("loginModuleId") || "0"),
    };
    return api.create(USER_SSO_API.USER_SSO_API + "Insert", payload);
  },

  // UPDATE METHOD
  updateRole: (payload_data: UserPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user?.userid,
      compid: user?.compid,
      branid: user?.branid,
    };
    return api.create(USER_SSO_API.USER_ROLE_API, payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: {
    id: number | null;
    userid?: number | null;
    updatereason: string;
  }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      compid: user?.compid,
      branid: user?.branid,
      id: payload_data.id,
      userid: payload_data.userid,
      updatedby: user?.userid,
      // moduleid: parseInt(sessionStorage.getItem("loginModuleId") || "0"),
      moduleid: process.env.REACT_APP_BYPASS_SSO === 'true'
        ? 3050
        : parseInt(sessionStorage.getItem("loginModuleId") || "0"),
      updatereason: payload_data.updatereason,
    };
    return api.create(USER_SSO_API.USER_SSO_API + "Delete", payload);
  },

  // USER DROPDOWN METHOD
  getUserDropdownData: (useLocal: boolean = false) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      userid: user?.userid,
      compid: user?.compid,
      branid: user?.branid,
    };
    return api.create(
      USER_SSO_API.USER_SSO_API + (useLocal ? "Dropdown" : "DropdownSSO"),
      payload,
    );
  },

  // ROLE DROPDOWN METHOD
  getRoleDropdownData: () => {
    const payload = {
      status: "A",
    };
    return api.create(Admin_API.Role_API + "Dropdown", payload);
  },
};
